import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import App from './App.vue'
import OfficialView from '@/views/OfficialView.vue'
import AdminView from '@/views/AdminView.vue'

const routes = [
  { path: '/', component: OfficialView },
  { path: '/admin', component: AdminView },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

const app = createApp(App)
app.use(router)
app.mount('#app')
